module.exports = __webpack_public_path__ + "static/img/ikonaWWW-OFF.c9f27299.png";